import React, { Component } from 'react';
import { Button, Modal } from 'semantic-ui-react'

class ConfirmModal extends Component {

  render() {
    const { open, close, translations, message, header, onProceed, yesLabel, noLabel } = this.props
    return (
      <Modal className='confirm-modal' size="tiny" open={ open } onClose={ close }>
        <Modal.Header>{ header }</Modal.Header>
        <Modal.Content>
          { message }
        </Modal.Content>
        <Modal.Actions>
          <Button fluid size='medium' className="new-plan-button" onClick={close}>
            { noLabel || translations.no }
          </Button>
          <Button color='teal' fluid size='medium' className="new-plan-button" onClick={onProceed}>
            { yesLabel || translations.yes }
          </Button>
        </Modal.Actions>
        <i className="delete icon" onClick={ close }></i>
      </Modal>
    )
  }
}

export default ConfirmModal



// WEBPACK FOOTER //
// ./src/components/confirm_modal.js